export default __webpack_public_path__ + "static/media/5-cloudxier-shooper-receiptvalidation.8ad92df1.jpg";